import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiDictionaryUrlEnum } from '@lib/enums';
import { IDictionaryItem } from '@lib/interfaces';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {IdNameInterface} from "@core/interfaces/id-name.interface";

@Injectable({
  providedIn: 'root',
})
export class DictionaryDataService {
  private host: string;

  constructor(
    private readonly http: HttpClient,
  ) {
    this.host = environment.host;
  }

  public getCouponList(): Observable<Array<IDictionaryItem>> {

    return this.http.get<Array<IDictionaryItem>>(`${this.host}${ApiDictionaryUrlEnum.couponStatus}`);
  }

  public getHelpRequestStatusList(): Observable<Array<IDictionaryItem>> {

    return this.http.get<Array<IDictionaryItem>>(`${this.host}${ApiDictionaryUrlEnum.helpRequestStatus}`);
  }

  public getMessengerTypeList(): Observable<Array<IDictionaryItem>> {

    return this.http.get<Array<IDictionaryItem>>(`${this.host}${ApiDictionaryUrlEnum.messengerType}`);
  }

  public getEventKindList(): Observable<Array<IDictionaryItem>> {

    return this.http.get<Array<IDictionaryItem>>(`${this.host}${ApiDictionaryUrlEnum.eventsKind}`);
  }

  public getEntityNameList(): Observable<Array<string>> {

    return this.http.get<Array<string>>(`${this.host}${ApiDictionaryUrlEnum.entityList}`);
  }

  public getIncidentStatuses(): Observable<IdNameInterface[]> {
    return this.http.get<IdNameInterface[]>(`${this.host}${ApiDictionaryUrlEnum.incidentStatus}`);
  }
}
